import { RootState } from "@services/Redux";
import * as React from "react";
import { useSelector } from "react-redux";
import whatsappImg from "../../assets/img/whatsapp.png";

const WhatsappButton: React.FC = () => {
  const { data: companyData, seller } = useSelector((state: RootState) => state.company);

  const whatsappUrl = React.useMemo(() => {
    if (companyData.whatsapp_button_url) return companyData.whatsapp_button_url;
    if (seller?.phone) return `https://api.whatsapp.com/send?phone=55${seller.phone?.replace(/\D+/g, "")}&text=Olá, gostaria de mais informações sobre o catálogo`;
    if (companyData.phone) {
      return `https://api.whatsapp.com/send?phone=55${companyData.phone?.replace(/\D+/g, "")}&text=Olá, gostaria de mais informações sobre o catálogo`;
    }
    return null;
  }, [companyData, seller]);

  if (!whatsappUrl || !companyData.is_whatsapp_button_enabled) return null;

  return (
    <a style={{ position: "fixed", right: 20, bottom: 20, zIndex: 2 }} href={whatsappUrl} target="_blank" rel="noopener noreferrer">
      <img src={whatsappImg} style={{ height: 45, width: 45 }} />
    </a>
  );
};

export default WhatsappButton;
